var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-layout',{staticClass:"layout-3"},[_c('keep-alive',{attrs:{"include":"developing"}},[_c('router-view',{staticClass:"content-body"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }